import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { LOGIN_PATH } from '../../config';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { completeLogin } from '../../store/authSlice';
import { FullPageProgress } from '../../components/FullPageProgress';

// Where Cognito returns the browser with ?code=. Exchanges it for tokens, then
// gets out of the way — nothing is rendered here on success, and navigating on
// clears the code from the URL.
//
// Not behind the guard: at the moment this runs there is no session yet.
export const AuthCallbackPage = () => {
  const dispatch = useAppDispatch();
  const { status, returnTo } = useAppSelector((state) => state.auth);

  useEffect(() => {
    // Fires twice under StrictMode — mount, unmount, mount. An authorization
    // code is single use, so the second exchange fails. The thunk's `condition`
    // is what actually prevents it; this effect stays simple on purpose.
    void dispatch(completeLogin());
  }, [dispatch]);

  if (status === 'authenticated') {
    // `returnTo` came back through the provider on the token exchange, so it
    // survives even though the app was unloaded in between.
    return <Navigate to={returnTo ?? '/'} replace />;
  }

  // Rejected, or there was no session to load. The error is already in the
  // store, so the login page shows it.
  if (status === 'unauthenticated') {
    return <Navigate to={LOGIN_PATH} replace />;
  }

  return <FullPageProgress label="Taking you to the Augment Toolkit…" />;
};
